<template>
	<v-text-field
		:id="id"
		:type="type"
		:ref="inputRef"
		:label="label"
		:loading="loading"
		:disabled="disabled"
		:readonly="readonly"
		:hide-details="hideDetails"
		outlined
		:rules="rules"
		class="mt-3 pt-0"
		v-model.trim="textinput"
		:append-outer-icon="appendOuterIcon"
		:append-icon="appendIcon"
		:placeholder="placeholder"
		v-on:click:append="$emit('click:append', true)"
		v-on:click:append-outer="$emit('click:append-outer', true)"
		v-on:onchange="$emit('onchange', true)"
		v-on:keyup="$emit('keyup', true)"
		v-on:keyup.enter="$emit('keyup-enter', true)"
		v-bind="vBindAttrs"
		v-on="vOn"
		v-on:keypress="alphaNumeric ? isAlphaNumeric($event) : null"
	></v-text-field>
</template>
<script>
export default {
	name: "text-input",
	model: {
		prop: "value",
		event: "input",
	},
	props: {
		value: {
			type: [String, Number],
			default: null,
		},
		rules: {
			type: [Array, Object],
			default: () => {
				return [];
			},
		},
		type: {
			type: String,
			default: "text",
		},
		placeholder: {
			type: String,
			default: null,
		},
		inputRef: {
			type: String,
			default: "textInput",
		},
		id: {
			type: String,
			default: null,
		},
		label: {
			type: String,
			default: null,
		},
		vBindAttrs: {
			type: Object,
			default: () => {
				return {};
			},
		},
		vOn: {
			type: Object,
			default: () => {
				return {};
			},
		},
		hideDetails: {
			type: Boolean,
			default: false,
		},
		alphaNumeric: {
			type: Boolean,
			default: false,
		},
		appendOuterIcon: {
			type: String,
			default: null,
		},
		appendIcon: {
			type: String,
			default: null,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		readonly: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			textinput: null,
		};
	},
	watch: {
		value() {
			this.textinput = this.value;
		},
		textinput() {
			this.$emit("input", this.textinput);
			this.$emit("change", this.textinput);
		},
	},
	mounted() {
		this.textinput = this.value;
	},
};
</script>
